import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import DataRepository from '../data-framework/data-repository';
import QualityIndicators from '../helpers/quality-indicators';

    function EndpointStatusGridFormatter(params, observableOptions) {
        var self = this;

        self.observableOptions = observableOptions;
        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.filterFormatter = new FilterFormatter();

        self.dataRepository = DataRepository.getInstance();
        self.observableFormattedData = ko.observable({});
        self.subscriptions = [];

        var type = _.get(params, 'type');
        self.isCallControl = type === "CallControl";
        self.isBridge = type === "Bridge";
    }

    function ComposeData(sourceList, endpointCallData, options, formatters, metadata) {
        var headers = getHeaders(_.get(options, 'display'), metadata.searchgrid.headers);
        var rowProperties = getRowProperties(headers, metadata.endpointStatusColumnDictionary);
        const widths = getWidths(headers, metadata.endpointStatusColumnDictionary);
        if ($.isEmptyObject(sourceList)) {
            return formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths);
        }

        var finalList = [];
        var statusfilter = _.get(options, 'filter.statuses');
        var endpointfilter = _.get(options, 'filter.criteria');
        var searchFilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));

        var innerheaders = metadata.options.innerheaders;

        // Filter List according to option.filter
        var list = _.chain(sourceList).filter(function(item) {
            // We create this new property because the Endpoint Tag filter defined data-repository looks for this property
            // TODO: Refactor so filters can refer to a list of properties instead of creating properties that aggregate others.
            if (item.tags && item.tmsTag) {
                item._allTags = item.tags + ',' + item.tmsTag;
            }
            else {
                item._allTags = item.tags || item.tmsTag || '';
            }

            var hasRtData = item.hasDetail === 'true' && _.get(item, 'RtData[0]', null);

            item.numcalls = (hasRtData && parseInt(_.get(item, 'RtData[0].numCalls[0].text', -1)) >= 0) ? parseInt(item.RtData[0].numCalls[0].text) : null;

            var qualityIndicator = item.numcalls ? item.qualityIndicator : -1;

            item.qualityString = (qualityIndicator > 0) ? QualityIndicators.getQualityString(qualityIndicator) : '';

            var statusmatch = _.isEmpty(statusfilter) || formatters.gridFormatterCommon.matchStatusFilter(item.status, statusfilter);
            var endpointmatch = _.isEmpty(endpointfilter) || _.includes(_.toLower(item.name), _.toLower(endpointfilter));
            var searchmatch = _.isEmpty(searchFilter) || formatters.filterFormatter.matchAll(item, searchFilter);

            return statusmatch && endpointmatch && searchmatch;
        })
        // Format filtered list's items
        .map(function(item) {
            var aliases = item.aliases ? item.aliases.split("/") : [];

            item.sip = aliases[0] || "";
            item.h323 = aliases[1] || "";
            item.e164 = aliases[2] || "";

            var innerrows = null;
            var hasdetail = item.hasDetail === 'true';
            var rtdata = { numCalls: [{ text: -1 }], MaxPacketLossPercent: [{ text: 0 }], MaxJitter: [{ text: 0 }] };

            if (hasdetail === "true") {
                rtdata = item.RtData[0];
                innerrows = ko.observableArray(GetCallQualityDataForStatus(rtdata, endpointCallData, formatters.gridFormatterCommon, formatters.formatterCommon));
            }
            return getListItem(item, headers, innerheaders, innerrows, formatters.gridFormatterCommon, formatters.formatterCommon, metadata.endpointStatusColumnChoices);
        }).value();

        var sortedList = formatters.gridFormatterCommon.sortList(list, rowProperties, options);
        var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);

        pagedList.forEach(function (item) {
            finalList.push(item.displayItem);
        });

        return {
            maxCount: list.length,
            rows: finalList,
            rowProperties: rowProperties,
            headers: headers,
            widths: widths,
            innerRowDisplayIndex: (pagedList.length > 0) ? pagedList[0].innerRowDisplayIndex : -1,
            listOfEndpoints: getListOfEndpoints(sourceList)
        };
    }

    function getRowProperties(colNames, colDictionary) {
        var rowProperties = [];
        _.forEach(colNames, function(colName) {
            if (colDictionary[colName]) {
                rowProperties.push(colDictionary[colName].propName);
            }
        });
        return rowProperties;
    }

    function getHeaders(colNames, allColumnNames) {
        var headers;

        if (_.isEmpty(colNames)) {
            headers = allColumnNames;
        }
        else {
            headers = [];
            if (!_.includes(colNames, 'Name')) {
                headers.push('Name'); // Name column is always present
            }
            headers = headers.concat(colNames);
        }
        return headers;
    }

    function getWidths(colNames, colDictionary) {
        var widthRatios = [];
        var widths = [];
        var sum = 0;

        _.forEach(colNames, function(colName) {
            var columnMetadata = colDictionary[colName];
            if (columnMetadata) {
                widthRatios.push(columnMetadata.widthRatio);
                sum = sum + columnMetadata.widthRatio;
            }
        });
        widthRatios.forEach(function (widthRatio) {
            widths.push('' + Math.round(widthRatio * 100 / sum) + '%');
        });
        return widths;
    }

    function getListOfEndpoints(sourceList) {
        return _.map(sourceList, 'name');
    };

    function GetCallQualityDataForStatus(rtdata, endpointCallData, gridformattercommon, formatterCommon) {
        var result = [];

        if (!_.isEmpty(_.get(rtdata, 'calls'))) {
            for (var i = 0; i < rtdata.calls.length; i++) {
                var call = rtdata.calls[i];
                var id = _.get(call, 'id[0].text');

                if (!_.isEmpty(id) && !_.isEmpty(_.get(endpointCallData, '[' + id + ']'))) {
                    var list = endpointCallData[id];
                    var obj = list[list.length - 1];

                    if (obj) {
                        result.push({
                            remoteaddr: formatterCommon.getSpanTitle(obj.remoteaddr),
                            calltype: obj.calltype,
                            packetloss: gridformattercommon.getQualityMetricMarkupWithoutUnits(obj.packetlossQualityIndicator, obj.maxPacketloss),
                            jitter: gridformattercommon.getQualityMetricMarkupWithoutUnits(obj.jitterQualityIndicator, obj.maxJitter),
                            details: "<a href='#quality/" + encodeURIComponent(id) + "?nosave=true' title='quality details'>Details</a>"
                        });
                    }
                }
            }
        }
        return result;
    }

    function getListItem(sourceItem, colNames, innerheaders, innerrows, gridformatterCommon, formatterCommon, endpointStatusColumnChoices) {
        var item = _.extend({}, sourceItem, {
            id: sourceItem.id,
            name: formatterCommon.sanitize(sourceItem.name),
            altName: formatterCommon.sanitize(sourceItem.altName),
            description: formatterCommon.sanitize(sourceItem.description),
            price: formatterCommon.sanitize(sourceItem.price),
            location: formatterCommon.sanitize(sourceItem.location),
            tmsTags: formatterCommon.sanitize(sourceItem.tmsTags),
            _allTags: formatterCommon.sanitize(sourceItem._allTags),
            tags: formatterCommon.sanitize(sourceItem.tags)
        });
        var displayItem = _.extend({}, item, {
            id: sourceItem.id,
            name: gridformatterCommon.getSolarWindsAndDetailLink(formatterCommon.sanitize(sourceItem.name), null, sourceItem.id)
        });

        var hasdetail = sourceItem.hasDetail === "true";
        var numcalls = null;

        if (hasdetail) {
            var rtdata = sourceItem.RtData[0];
            numcalls = parseInt(_.get(rtdata, 'numCalls[0].text', '0'));
        }

        var statusnum = gridformatterCommon.convertStatusToNumber(sourceItem.status);

        var innerRowDisplayIndex = 1;

        _.forEach(endpointStatusColumnChoices, function (choice) {
            if (_.includes(colNames, choice)) {
                switch (choice) {
                    case "SIP":
                        item.sip = sourceItem.sip;
                        displayItem.sip = formatterCommon.getSpanTitle(sourceItem.sip);
                        break;
                    case "H323":
                        item.h323 = sourceItem.h323;
                        displayItem.h323 = formatterCommon.getSpanTitle(sourceItem.h323);
                        break;
                    case "E164":
                        item.e164 = sourceItem.e164;
                        displayItem.e164 = formatterCommon.getSpanTitle(sourceItem.e164);
                        break;
                    case "Dir#":
                        item.dn = sourceItem.dn || '';
                        displayItem.dn = formatterCommon.getSpanTitle(item.dn);
                        break;
                    case "Model":
                        item.model = sourceItem.model || '';
                        displayItem.model = formatterCommon.getSpanTitle(item.model);
                        break;
                    case "Firmware":
                        item.firmware = sourceItem.firmware;
                        displayItem.firmware = formatterCommon.getSpanTitle(sourceItem.firmware);
                        break;
                    case "Status":
                        item.status = statusnum;
                        displayItem.status = gridformatterCommon.getStatusMarkupForEndpoint(item.status);
                        break;
                    case "H/W":
                        item.hwstatus = sourceItem.AVS ? gridformatterCommon.getHwStatusValue(sourceItem.AVS) : 0;
                        displayItem.hwstatus = sourceItem.AVS ? gridformatterCommon.getHwStatusMarkup(sourceItem.AVS) : '';
                        break;
                    case "Host":
                        item.host = sourceItem.host;
                        displayItem.host = gridformatterCommon.getLinkWithHost(sourceItem.host);
                        break;
                    case "Num Calls":
                        item.numcalls = hasdetail ? numcalls : 0;
                        displayItem.numcalls = hasdetail ? numcalls : '';
                        break;
                    case "Quality":
                        item.qualityIndicator = hasdetail ? sourceItem.qualityIndicator : -1;
                        displayItem.qualityIndicator = hasdetail ? gridformatterCommon.getQualityMarkup(sourceItem.qualityIndicator) : "";
                        break;
                };
            }
        });

        item.innerheaders = innerheaders;
        displayItem._innerheaders = innerheaders;

        item.innerrows = innerrows;
        displayItem._innerrows = innerrows;

        displayItem._showInnerPager = false;

        item.displayItem = displayItem;
        item.innerRowDisplayIndex = innerRowDisplayIndex;

        return item;
    }

    EndpointStatusGridFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(ComposeData(
            self.dataRepository.endpointStatusData(),
            self.dataRepository.endpointCallData(),
            self.observableOptions(),
            {
                filterFormatter: self.filterFormatter,
                gridFormatterCommon: self.gridFormatterCommon,
                formatterCommon: self.formatterCommon

            },
            self.dataRepository.getEndpointsMetadata()
        ));
    };

    EndpointStatusGridFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    EndpointStatusGridFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    EndpointStatusGridFormatter.prototype.initialize = function (dataRepository, callback) {
        var self = this;
        self.dataRepository = dataRepository;
        self.subscriptions.push(dataRepository.endpointStatusData.subscribe(function () { self.DataUpdated(); }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.endpointStatusData())) {
            self.RefreshData();
        }
    };

    EndpointStatusGridFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    EndpointStatusGridFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default EndpointStatusGridFormatter;
